import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { trackDatadogRumError } from 'utils/initDatadogRum';
import { IBackOfEnvelopeResponse, IBackOfEnvelopeQueryParams } from '../types';

const getBackOfEnvelopeScenarios = async ({ orgId, dealId }: IBackOfEnvelopeQueryParams & { dealId?: number }): Promise<IBackOfEnvelopeResponse> => {
    const queryParams = dealId ? `?deal_id=${dealId}` : '';
    const { data } = await axiosInstance.get(`${API_ENDPOINTS.BACK_OF_ENVELOPE_SCENARIOS(orgId)}${queryParams}`);
    if (!Array.isArray(data?.items)) {
        trackDatadogRumError(
            new Error('[useGetBackOfEnvelopeScenarios] Expected items array response'),
            { receivedType: typeof data?.items, receivedValue: data },
        );
    }
    return {
        ...data,
        items: Array.isArray(data?.items) ? data.items : [],
    };
};

export const useGetBackOfEnvelopeScenarios = ({ orgId, dealId, enabled = true }:
    IBackOfEnvelopeQueryParams & { dealId?: number; enabled?: boolean }) => useQuery<IBackOfEnvelopeResponse>({
        queryKey: ['back-of-envelope-scenarios', orgId, dealId],
        queryFn: () => getBackOfEnvelopeScenarios({ orgId, dealId }),
        staleTime: 5000,
        refetchOnMount: true,
        enabled,
    });
